import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

export const orderSuppliesInventoryConfigNow = {
  name: "orderSuppliesInventoryConfigNow" as const,
  input: z.object({
    configId: suppliesInventoryConfigIdFormat.schema,
    // Client-generated per confirm-modal open, so a double-click or a retry
    // attaches to the in-flight placement instead of charging twice. A fresh
    // modal means a fresh key, which is how repeat manual orders stay possible.
    idempotencyKey: z
      .string()
      .min(1)
      .max(64)
      .regex(/^[A-Za-z0-9_-]+$/),
    // Cases to order. Defaults to the config's reorder amount in the UI, but the
    // merchant can order a different amount for a one-off top-up.
    quantityCases: z.number().int().positive().max(10_000),
  }),
  output: z.discriminatedUnion("placed", [
    z.object({
      placed: z.literal(true),
      orderId: z.string(),
      orderName: z.string(),
    }),
    z.object({
      placed: z.literal(false),
      reason: z.enum(["not_eligible", "payment_failed"]),
      message: z.string().optional(),
    }),
  ]),
};
